<mw-core-toolbar
  [showLogo]="!form.allowSave"
  [showToggler]="false"
  [showFullscreenButton]="false"
  [allowBack]="form.allowSave"
  [title]="'CORE.PAGE.USER_PROFILE.my_profile' | translate"
>
  <button #btnProfile mat-icon-button (click)="onLogout()">
    <mat-icon fontSet="material-symbols-outlined">logout</mat-icon>
  </button>
</mw-core-toolbar>
<div class="mw-user-profile flex flex-1 overflow-auto bg-gray-100">
  <mw-form [sectionDividerWidth]="16" *ngIf="form.isReady">
    <mw-form-section
      [title]="'CORE.PAGE.USER_PROFILE.link_section_title' | translate"
      *ngIf="enableDevincoConnectLinking"
    >
      <!-- Linked account case -->
      <div *ngIf="form.linkedAccount">
        <div class="mb-[16px] text-body-2 text-secondary-dark">
          {{ 'CORE.PAGE.USER_PROFILE.default_msg' | translate }}
        </div>
        <div
          class="flex flex-col gap-[8px] md:flex-row md:items-center md:gap-[24px]"
        >
          <div>
            <div class="text-secondary-dark">Mobile Worker</div>
            <div class="text-body-2">{{ form.userName.value }}</div>
          </div>
          <mat-icon>link</mat-icon>
          <div>
            <div class="text-secondary-dark">Devinco Connect</div>
            <div class="text-body-2">{{ form.linkedAccount }}</div>
          </div>
        </div>
        <div class="my-[16px] grid grid-cols-1">
          <button
            mat-stroked-button
            (click)="onUnlinkAccount()"
            color="warn"
            class="place-self-start"
            [disabled]="unlinkInProgress$ | async"
          >
            {{ 'CORE.PAGE.USER_PROFILE.BUTTON.unlink_account' | translate }}
          </button>
        </div>
      </div>
      <!-- Not linked account case -->
      <div *ngIf="!form.linkedAccount">
        <div class="text-body-2 text-secondary-dark">
          {{ 'CORE.PAGE.USER_PROFILE.default_msg' | translate }}
        </div>
        <div
          class="mt-[16px] flex flex-row flex-wrap items-center gap-[24px]"
          *ngIf="form.linkWithUserName"
        >
          <div>
            <div class="text-secondary-dark">
              {{
                form.isDevincoConnectActive
                  ? 'Devinco Connect'
                  : 'Mobile Worker'
              }}
            </div>
            <div class="text-body-2">{{ form.userName.value }}</div>
          </div>
          <div>
            <div class="text-secondary-dark">
              {{
                form.isDevincoConnectActive
                  ? 'Mobile Worker'
                  : 'Devinco Connect'
              }}
            </div>
            <div class="text-body-2">
              {{ form.linkWithUserName }}
              <a
                class="ml-[24px] cursor-pointer self-end text-body-2"
                (click)="onLogoff()"
              >
                {{ 'CORE.PAGE.USER_PROFILE.BUTTON.logout' | translate }}
              </a>
            </div>
          </div>
        </div>
        <div class="my-[16px] md:grid md:grid-cols-2">
          <button
            mat-stroked-button
            (click)="onLogin()"
            *ngIf="!form.linkWithUserName"
            class="w-full md:w-auto md:place-self-start"
          >
            {{
              (form.isLinkWithMobileWorker
                ? 'CORE.PAGE.USER_PROFILE.BUTTON.login_with_mobile_worker'
                : 'CORE.PAGE.USER_PROFILE.BUTTON.login_with_devinco_connect'
              ) | translate
            }}
          </button>

          <button
            mat-flat-button
            color="accent"
            (click)="onLinkAccount()"
            *ngIf="form.linkWithUserName"
            [disabled]="linkInProgress$ | async"
            class="place-self-start"
          >
            {{ 'CORE.PAGE.USER_PROFILE.BUTTON.link_accounts' | translate }}
          </button>
        </div>
      </div>
    </mw-form-section>

    <mw-form-section
      [title]="'CORE.PAGE.USER_PROFILE.user_information' | translate"
    >
      <mat-form-field class="col-span-6">
        <mat-label>{{ 'CORE.PAGE.USER_PROFILE.email' | translate }}</mat-label>
        <input matInput [mwReadOnly]="true" [formControl]="form.userName" />
      </mat-form-field>

      <mat-form-field class="col-span-6 col-start-1">
        <mat-label>
          {{ 'CORE.PAGE.USER_PROFILE.first_name' | translate }}
        </mat-label>
        <input
          matInput
          [formControl]="form.firstName"
          [mwReadOnly]="!form.allowSave"
        />
        <mat-error *ngIf="form.getControlError(form.firstName)">
          {{ form.getControlError(form.firstName) | translate }}
        </mat-error>
      </mat-form-field>

      <mat-form-field class="col-span-6">
        <mat-label>
          {{ 'CORE.PAGE.USER_PROFILE.last_name' | translate }}
        </mat-label>
        <input
          matInput
          [formControl]="form.lastName"
          [mwReadOnly]="!form.allowSave"
        />
        <mat-error *ngIf="form.getControlError(form.firstName)">
          {{ form.getControlError(form.firstName) | translate }}
        </mat-error>
      </mat-form-field>

      <mat-form-field *ngIf="form.allowSave">
        <mat-label>
          {{ 'CORE.PAGE.USER_PROFILE.phone' | translate }}
        </mat-label>
        <mw-phone-input [formControl]="form.workPhoneNumber"></mw-phone-input>
      </mat-form-field>

      <mat-form-field>
        <mat-label>
          {{ 'CORE.PAGE.USER_PROFILE.default_language' | translate }}
        </mat-label>
        <mw-select
          bindValue="value"
          bindLabel="title"
          [items]="languages"
          [formControl]="form.userLanguage"
          [clearable]="false"
          [mwReadOnly]="!form.allowSave"
        ></mw-select>
      </mat-form-field>
      <div class="mb-[16px]" *ngIf="form.allowSave">
        <button mat-flat-button color="accent" (click)="onSave()">
          {{ 'CORE.PAGE.USER_PROFILE.BUTTON.save' | translate }}
        </button>
      </div>
    </mw-form-section>
  </mw-form>
</div>
